const namedColors = ['transparent'];

const cssNamedColors: {
	[K in (typeof namedColors)[number]]: {
		r: number;
		g: number;
		b: number;
		a: number;
	};
} = {
	transparent: { r: 255, g: 255, b: 255, a: 0 },
} as const;

export const hexToRGBAValues: (hex: string) => {
	r: number;
	g: number;
	b: number;
	a: number;
} = (hex: string) => {
	if (cssNamedColors[hex]) {
		return cssNamedColors[hex];
	}

	const hexColor = hex.replace('#', '');

	return {
		r: parseInt(hexColor.slice(0, 2), 16),
		g: parseInt(hexColor.slice(2, 4), 16),
		b: parseInt(hexColor.slice(4, 6), 16),
		a: parseFloat((parseInt(hexColor.slice(6, 8), 16) / 255).toFixed(2)),
	};
};
